import $ from 'jquery';
import modernizr from './vendor/modernizr-custom.js';
import branchBar from './modules/branch-bar';
import serviceCard from './modules/service-card';
import ops from './modules/ops';

//Initialize everything on document ready
$(document).ready(function() {
	branchBar.init();

	if ($('body').hasClass('service-card')) {
		serviceCard.init();
	} else {
		ops.init();
	}

});
